// church quote hide shows

$('.-loss-loc .radio').on('change', function() {

    $value = $('.-loss-loc .radio:checked').val();

    if ($value == 'Yes') {
        $('.loss-loc-hide').removeClass('hide');
        $('.loss-loc-hide-no').addClass('hide');
    } else {
        $('.loss-loc-hide').addClass('hide');
        $('.loss-loc-hide-no').removeClass('hide');
    }
})

$('.-sole-owner .radio').on('change', function() {

    $value = $('.-sole-owner .radio:checked').val();

    if ($value == 'No') {
        $('.sole-owner-hide').removeClass('hide');
    } else {
        $('.sole-owner-hide').addClass('hide');
    }
})

$('.-responsible .radio').on('change', function() {

    $value = $('.-responsible .radio:checked').val();

    if ($value == 'Yes') {
        $('.responsible-hide').removeClass('hide');
    } else {
        $('.responsible-hide').addClass('hide');
    }
})

$('.-existing .radio').on('change', function() {

    $value = $('.-existing .radio:checked').val();

    if ($value == 'Yes') {
        $('.existing-hide').removeClass('hide');
    } else {
        $('.existing-hide').addClass('hide');
    }
})

$('.-currently-open .radio').on('change', function() {

    $value = $('.-currently-open .radio:checked').val();

    if ($value == 'No') {
        $('.currently-open-hide').removeClass('hide');
    } else {
        $('.currently-open-hide').addClass('hide');
    }
})

$('.claims-details-next').on('click', function(e){
    e.preventDefault();

    $('.your-details').addClass('completed').children().removeClass('open');
    $('.loss-damage').children().addClass('open');
})

$('.loss-damage-next').on('click', function(e){
    e.preventDefault();

    if ($('.prem-req').is(':checked')) {

        $('.loss-damage').addClass('completed').children().removeClass('open');
        $('.loss-details').children().addClass('open');
    } else {

        if (! $('.prem-req').is(':checked')) {
            $('.prem-req').next().css({
                'color': '#ED3D41'
            });
        }
    }

    $('.prem-req').on('change', function(){
        if ($('.prem-req').is(':checked')) {
            $('.prem-req').next().css({
                'color': '#000'
            })

            $('.prem-req').next().next().next().css({
                'color': '#000'
            });
        }
    })
})

$('.loss-details-next').on('click', function(e){
    e.preventDefault();

    if ($('.date-req').val() != "") {

      $('.loss-details').addClass('completed').children().removeClass('open');
      $('.building-damage').children().addClass('open');
    } else {

      if ($('.date-req').val() == "") {
          $('.date-req').css({
              'border': '1px solid #ED3D41',
              'background-color': '#FCC4C5'
          });
      }
    }

    $('.date-req').on('keyup', function(){
        if ($('.date-req').val() != "") {
            $(this).css({
                'border': '1px solid #000',
                'background-color': '#fff'
            })
        }
    })
})

$('.building-damage-next').on('click', function(e){
    e.preventDefault();

    $('.building-damage').addClass('completed').children().removeClass('open');
    $('.contents-details').children().addClass('open');

})

$('.contents-details-next').on('click', function(e){
    e.preventDefault();

    $('.contents-details').addClass('completed').children().removeClass('open');
    $('.additional-info-claims').children().addClass('open');

})

$('.finished-form').on('click', function(e){

  if (! $('.loss-req').is(':checked')) {
      e.preventDefault;

      $('.loss-req').next().css({
          'color': '#ED3D41'
      });
      $('.flood-req').next().css({
          'color': '#ED3D41'
      });
      $('.damage-req').next().css({
          'color': '#ED3D41'
      });
      $('.sole-req').next().css({
          'color': '#ED3D41'
      });
      $('.deco-req').next().css({
          'color': '#ED3D41'
      });
      $('.time-req').next().css({
          'color': '#ED3D41'
      });
      $('.reg-req').next().css({
          'color': '#ED3D41'
      });
      $('.open-req').next().css({
          'color': '#ED3D41'
      });
  }

  $('.loss-req').on('change', function(){
      if ($('.loss-req').is(':checked')) {
          $('.loss-req').next().css({
              'color': '#000'
          });

          $('.loss-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.flood-req').on('change', function(){
      if ($('.flood-req').is(':checked')) {
          $('.flood-req').next().css({
              'color': '#000'
          });

          $('.flood-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.damage-req').on('change', function(){
      if ($('.damage-req').is(':checked')) {
          $('.damage-req').next().css({
              'color': '#000'
          });

          $('.damage-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.sole-req').on('change', function(){
      if ($('.sole-req').is(':checked')) {
          $('.sole-req').next().css({
              'color': '#000'
          });

          $('.sole-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.deco-req').on('change', function(){
      if ($('.deco-req').is(':checked')) {
          $('.deco-req').next().css({
              'color': '#000'
          });

          $('.deco-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.time-req').on('change', function(){
      if ($('.time-req').is(':checked')) {
          $('.time-req').next().css({
              'color': '#000'
          });

          $('.time-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.reg-req').on('change', function(){
      if ($('.reg-req').is(':checked')) {
          $('.reg-req').next().css({
              'color': '#000'
          });

          $('.reg-req').next().next().next().css({
              'color': '#000'
          });
      }
  })
  $('.open-req').on('change', function(){
      if ($('.open-req').is(':checked')) {
          $('.open-req').next().css({
              'color': '#000'
          });

          $('.open-req').next().next().next().css({
              'color': '#000'
          });
      }
  })

})

$('.accord-title').on('click', function() {
    if ($(this).parent().hasClass('completed') && ! $(this).parent().children().hasClass('open')) {
        $(this).parent().children().addClass('open');

    } else if ($(this).parent().hasClass('completed') && $(this).parent().children().hasClass('open')) {
        $(this).parent().children().removeClass('open');
    }
});
